import { MasterIndex } from "verdi-web-client";

function getDeviceFromMasterIndex(deviceId: string) {
    return (
        MasterIndex.irrigationDevice.byID[deviceId] ??
        MasterIndex.blockValve.byID[deviceId] ??
        MasterIndex.thirdPartyDevice.byID[deviceId]
    );
}

/** Returns the stored verdiId for a device in MasterIndex, when loaded. */
export function getVerdiIdFromMasterIndex(deviceId: string): string | undefined {
    return getDeviceFromMasterIndex(deviceId)?.verdiId;
}
